
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { TabData } from "../types";
import { Dispatch, SetStateAction } from "react";
import { useIsMobile } from "@/hooks/use-mobile";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface ReportTabsProps {
  tabs: TabData[];
  activeTab: string;
  onTabChange: Dispatch<SetStateAction<string>>;
}

export const ReportTabs = ({ 
  tabs, 
  activeTab,
  onTabChange
}: ReportTabsProps) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <div className="w-full mb-4">
        <Select value={activeTab} onValueChange={onTabChange}>
          <SelectTrigger className="w-full bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 border-border/40">
            <SelectValue placeholder="Select view" />
          </SelectTrigger>
          <SelectContent>
            {tabs.map((tab) => (
              <SelectItem
                key={tab.id}
                value={tab.id}
                className="cursor-pointer"
              >
                {tab.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    );
  }

  return (
    <Tabs value={activeTab} onValueChange={onTabChange} className="w-full">
      <div className="border-b mb-4">
        <TabsList className="bg-transparent mb-0">
          {tabs.map((tab) => (
            <TabsTrigger
              key={tab.id}
              value={tab.id}
              className={`px-6 py-3 data-[state=active]:border-b-2 data-[state=active]:border-primary data-[state=active]:text-primary data-[state=active]:shadow-none rounded-none border-b-2 border-transparent ${
                activeTab === tab.id
                  ? "border-primary text-primary"
                  : ""
              }`}
            >
              {tab.label}
            </TabsTrigger>
          ))}
        </TabsList>
      </div>
    </Tabs>
  );
};
